import {i18n} from '~/plugins/i18n'
import { getErrorCodeInfo } from '~/utils/error-code'
import { getDeviceModel } from '~/utils/dashboard'

// export const code = i18n.t('code.code')
// 공통 JSON 코드의 그룹키로 해당 JSON List 반환
export function getCodeJsonRow (gKey) {
  const retVal = ''
  const code = i18n.t('code.code')
  const len = code.length
  for (let i = 0; i < len; i++) {
    const obj = code[i]
    if (obj.group_key === gKey && obj.list) {
      return obj.list
    }
  }
  return retVal
}
// 공통 JSON 코드의 그룹키로 해당 JSON List 반환
export function getCodeJsonRule (gKey, rKey) {
  const retVal = ''
  const code = i18n.t('code.code')
  const len = code.length
  for (let i = 0; i < len; i++) {
    const obj = code[i]
    if (obj.group_key === gKey) {
      let nObj = ''
      rKey.forEach((key) => {
        if (nObj !== '') {
          const tmp = _.cloneDeep(nObj[key])
          nObj = _.cloneDeep(tmp)
        } else {
          nObj = _.cloneDeep(obj[key])
        }
      })
      if (nObj.list) {
        return nObj.list
      }
    }
  }
  return retVal
}
// // 공통 JSON 코드의 그룹키로 해당 JSON List 반환
// export function getCodeJsonRow (comCode, gKey) {
//   let retVal = ''
//   let code = comCode.code
//   let len = code.length
//   for (let i = 0; i < len; i++) {
//     let obj = code[i]
//     if (obj.group_key === gKey) {
//       if (obj.list) {
//         return obj.list
//       }
//     }
//   }
//   return retVal
// }
// JSON 추출용 : json 에서 현재의 row 반환
export function getObjects (obj, key, val) {
  let objects = []
  for (const i in obj) {
    if (!obj.hasOwnProperty(i)) continue
    if (typeof obj[i] === 'object') {
      objects = objects.concat(getObjects(obj[i], key, val))
    } else if (i === key && obj[key] === val) {
      objects.push(obj)
    }
  }
  return objects
}

export function getTreeData (data, option) {
  const returnTree = []
  const sameleLevel = data.filter((item) => {
    return item[option.level] === data[0][option.level]
  })
  sameleLevel.forEach(element => {
    const id = element[option.id]
    returnTree.push(treeConvert(data, id, option)[0])
  })
  return returnTree
}
// treeConvert
export function treeConvert (data, id, option) {
  const convResult = []
  let obj = {}
  const state = 'normal'
  let groupClass = `ps-icon-device ps-icon-24-${state}-MFI-tree padL30` // default device icon
  const parent = data.filter(function (itm) {
    return itm[option.id] === id
  })
  obj = parent[0]
  obj.label = parent[0][option.label]
  obj.level = parent[0][option.level]
  obj.type = parent[0][option.type]
  obj.model = parent[0][option.model]
  // 장비 유형
  // 0: 장비 그룹, 1: Stand-Alone 장비, 2: Master 장비, 3: Slave 장비, 4: TAMS Group, 5: TAMS Master, 6: TAMS Slave, 7: TAMS Sub Root, 8 : TAMS Sub Group
  if (Number(parent[0].dtype) === 0 || Number(parent[0].dtype) === 4) { // Device Group icon
    groupClass = 'ps-icon-device ps-icon-icon-group padL30'
  } else if (Number(parent[0].dtype) === 7) {
    groupClass = 'ps-icon-device ps-icon-icon-sub-tams-root padL30'
  } else if (Number(parent[0].dtype) === 8) {
    groupClass = 'ps-icon-device ps-icon-icon-sub-tams-group padL30'
  } else {
    if (Number(parent[0].dtype) === 5 || Number(parent[0].dtype) === 6) { // TAMS
      groupClass = `ps-icon-device ps-icon-24-${state}-TAMS`
    } else if (parent[0].model === 9) { // MF 2
      groupClass = `ps-icon-device ps-icon-24-${state}-MF2`
    } else if (parent[0].model === 10) { // MFI
      groupClass = `ps-icon-device ps-icon-24-${state}-MFI`
    } else if (parent[0].model === 11) { // MFD
      groupClass = `ps-icon-device ps-icon-24-${state}-MFD`
    } else if (parent[0].model === 20) { // Bluemax NGF
      groupClass = `ps-icon-device ps-icon-24-${state}-NGF`
    } else if (parent[0].model === 21) { // Bluemax IPS
      groupClass = `ps-icon-device ps-icon-24-${state}-IPS`
    } else if (parent[0].model === 22) { // Bluemax WIPS
      groupClass = `ps-icon-device ps-icon-24-${state}-WIPS`
    }

    if (state === 'normal') {
      groupClass = `${groupClass}-tree`
    }
    groupClass = `${groupClass} padL30`
  }
  obj.groupClass = groupClass
  obj.name = `${parent[0].device_uname}`
  obj.group_name = `${parent[0].device_group_name}`

  if (typeof parent[0].btnLabel !== 'undefined') {
    obj.btnLabel = parent[0].btnLabel
  }
  if (parent[0].img !== undefined) {
    obj.img = parent[0].img
  }
  obj.header = 'custom'
  obj.disabled = null
  obj.selectableNodes = true
  const child = data.filter(function (itm) {
    return itm[option.parent] === id
  })
  if (child.length > 0) {
    obj.children = []
    child.forEach((item) => {
      const objChild = treeConvert(data, item[option.id], option)
      obj.children.push(objChild[0])
    })
  }
  convResult.push(obj)
  return convResult
}
function getIconClass (treeNode, state, groupClass = '') {
  if ([5, 6].includes(treeNode.device_type)) return `ps-icon-device ps-icon-24-${state}-TAMS`
  if ([9].includes(treeNode.device_type)) return `ps-icon-device ps-icon-24-${state}-MF2`
  if ([10].includes(treeNode.device_type)) return `ps-icon-device ps-icon-24-${state}-MFI`
  if ([11].includes(treeNode.device_type)) return `ps-icon-device ps-icon-24-${state}-MFD`
  if ([20].includes(treeNode.device_type)) return `ps-icon-device ps-icon-24-${state}-NGF`
  if ([21].includes(treeNode.device_type)) return `ps-icon-device ps-icon-24-${state}-IPS`
  if ([22].includes(treeNode.device_type)) return `ps-icon-device ps-icon-24-${state}-WIPS`
  if (state === 'normal') return `${groupClass}-tree`
  return `${groupClass} padL30`
}

function getDeviceIconClass (treeNode, state, groupClass = '') {
  // [장비 유형] 0: 장비 그룹, 1: Stand-Alone 장비, 2: Master 장비, 3: Slave 장비, 4: TAMS Group, 5: TAMS Master, 6: TAMS Slave
  if ([0, 4].some(type => type === treeNode.device_type)) return 'ps-icon-device ps-icon-icon-group padL30' // Device Group icon
  else if (treeNode.device_model_type === 7) return 'ps-icon-device ps-icon-icon-sub-tams-root padL30'
  else if (treeNode.device_model_type === 8) return 'ps-icon-device ps-icon-icon-sub-tams-group padL30'
  return getIconClass(treeNode, state, groupClass)
}
export function deviceDataTreeConvert (data, deviceId, filter = false, tickable = true, level = 0) {
  try {
    const convResult = []
    const obj = {}
    let childCnt = 0
    const parent = data.filter((itm) => { return itm.device_id === deviceId })
    const treeNode = parent[0]
    const event = getErrorCodeInfo(treeNode.event_code || 0)
    const model = getDeviceModel(treeNode.device_model_type)
    const state = event.state
    let groupClass = `ps-icon-device ps-icon-24-${state}-MFI-tree padL30` // default device icon
    obj.label = treeNode.device_uname
    obj.device_id = treeNode.device_id
    obj.parent_device_id = treeNode.parent_device_id
    obj.device_type = treeNode.device_type
    obj.device_model_type = treeNode.device_model_type
    obj.device_mng_type = treeNode.device_mng_type
    obj.level = level + 1
    obj.slaveClass = (filter && (treeNode.device_type === 3 || treeNode.device_type === 6)) ? 'padL20' : ''
    obj.disabled = (_.isUndefined(treeNode.disabled)) ? false : treeNode.disabled
    obj.device_sum = treeNode.device_sum
    // 툴팁 관련
    obj.issueUp = event.msg //  미복구 이벤트
    obj.model_uname = model.length > 0 ? model.toUpperCase() : i18n.t('cmn.unknown')
    // Icon 설정
    groupClass = getDeviceIconClass(treeNode, state, groupClass)
    obj.groupClass = groupClass
    obj.name = `${treeNode.device_uname}`
    obj.group_name = `${treeNode.device_group_name}`
    if (typeof treeNode.btnLabel !== 'undefined') obj.btnLabel = treeNode.btnLabel
    if (treeNode.avatar !== undefined) obj.avatar = treeNode.avatar
    if (treeNode.icon !== undefined) obj.icon = treeNode.icon
    if (treeNode.img !== undefined) obj.img = treeNode.img
    obj.header = 'custom'
    // children data
    let child = data.filter((itm) => { return itm.parent_device_id === deviceId })
    // 장비 유형 (0: 장비 그룹, 1: Stand-Alone 장비, 2: Master 장비, 3: Slave 장비, 4: TAMS Group, 5: TAMS Master, 6: TAMS Slave)
    // TAMS Master, NGF Master인 경우 하위 Slave장비가 동일한 depth까지 상승되었으므로 재귀되지 않도록 리셋
    // (2020-11-11) 단, 이미 등록된 Master 장비가 롤백 혹은 장비 교체 등의 이유로 Stand-alone이 되는 경우 간헐적 발생되기에 device_type: 1까지 고려
    if (filter && [1, 2, 5].includes(obj.device_type) && _.size(child) > 0) {
      child = []
    } else if (filter && obj.device_id !== 1 && _.size(child) > 0) {
      const childIdList = _.map(child, 'device_id')
      const slaveChild = data.filter((itm) => {
        // 3: Slave 장비, 6: TAMS Slave > Slave 장비만 Filter 추가
        return (_.includes(childIdList, itm.parent_device_id) && [3, 6].includes(itm.device_type))
      })
      // Slave 장비가 Master 장비에 속하도록 추가
      if (_.size(slaveChild) > 0) {
        _.forEach(_.groupBy(slaveChild, 'parent_device_id'), (items, key) => {
          const pId = Number(key)
          const pIdx = _.findIndex(child, ['device_id', pId])
          child.splice(pIdx + 1, 0, items)
          child = _.flattenDepth(child)
        })
      }
    }
    obj.mode = `${treeNode.mode}`
    // 자식이 있는 경우만 선택 가능(tickable = true)
    obj.tickable = true
    if (child.length > 0) {
      obj.children = []
      child.forEach((item) => {
        const objChild = deviceDataTreeConvert(data, item.device_id, filter, tickable, obj.level)
        obj.children.push(objChild[0])
        // Slave 장비가 있을 경우 cnt 추가
        childCnt += objChild[0].childCnt
        if (item.device_type !== 0) {
          childCnt++
        }
      })
    } else if ([0, 4].some(type => type === obj.device_type)) { // Device Group
      obj.tickable = tickable
    }
    obj.childCnt = childCnt
    convResult.push(obj)
    return convResult
  } catch (e) { return [] }
}

// 특정한 키에 해당하는 오브젝트 반환 (배열 재배치용)
export function getChildObj (arr, key) {
  let result = ''
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].pid === key) {
      const obj = {
        obj: arr[i],
        idx: i,
        nkey: arr[i].nkey,
        pid: arr[i].pid
      }
      result = obj
      break
    }
  }
  return result
}

// 인터페이스 리스트를 테이블 트리 구조로 변환
export function ifcDataTreeConvert (data) {
  const parent = []
  let obj = [], child = {}
  _.forEach(data, (items) => {
    const key = items.parent_name
    const isTrue = key === ''
    if (isTrue) {
      items.level = 0
      parent.push(items)
    } else {
      items.level = 1
      if (_.has(child, key)) {
        child[key].push(items)
      } else {
        obj = [items]
        child = _.assignIn(child, _.zipObject([key], [obj]))
      }
    }
  })

  if (_.size(child) > 0) {
    _.forEach(child, (value, key) => {
      const idx = _.findIndex(parent, ['name', key])
      parent[idx].children = value
    })
  }
  return _.cloneDeep(parent)
}
